export default "__VITE_ASSET__D27E_nqI__"